import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaInformacionConfiguracionEditarComponent {
  idProyecto
  idNomina
  calculado
  acumulado
  onChange
  onClose
  proyectoId = null
  no_deducible = null
  omitir_carga_social_pendiente = null
  error = null
  data = undefined
  actualizando = false
  form

  constructor ($q, $catalogos, NominasNominaStatus, NominasCatalogos, NominasNominaConfiguracion) {
    this.$q = $q
    this.$catalogos = $catalogos
    this.NominasNominaStatus = NominasNominaStatus
    this.NominasCatalogos = NominasCatalogos
    this.NominasNominaConfiguracion = NominasNominaConfiguracion
  }

  $onInit () {
    this.$promise = this.$q.all([
      this.NominasNominaStatus.get(this.idProyecto, this.idNomina)
        .then(({data}) => {
          this.status = {
            cargado: data.status !== 'A',
            aprobado: data.status_aprobado,
            calculado: data.status_calculado,
            cotizado: data.status_cotizado,
            maquilado: data.status_maquilado,
            pagado: data.status_pagado,
            timbrado: data.status_timbrado,
          }
        }),
      this.NominasNominaConfiguracion.get(this.idProyecto, this.idNomina)
        .then(({data}) => (this.data = data)),
      this.NominasCatalogos.esquemas(this.idProyecto)
        .then(({data}) => {
          this.esquemas = data.map((item) => ({
            ...item,
            id_metodo_calculo_comision: +item.id_metodo_calculo_comision,
            id_metodo_calculo_suministro: +item.id_metodo_calculo_suministro,
            id_regimen_fiscal: +item.id_regimen_fiscal,
            id_tipo_comision: +item.id_tipo_comision,
            id_tipo_nomina: +item.id_tipo_nomina,
          }))
        }),
      this.$catalogos.get('monedas')
        .then((data) => this.monedas = data.map((item) => ({id: +item.ID_Moneda, descripcion: item.Moneda}))),
    ])
  }

  actualizar () {
    if (this.actualizando) return

    this.actualizando = true
    this.error = null

    return this.NominasNominaConfiguracion.put(this.idProyecto, this.idNomina, this.data)
      .then(() => (this.onChange({$event: {data: this.data}})))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.actualizando = false))
  }

  cancelar (pristine) {
    if (!pristine) return
    this.cerrar()
  }

  cerrar () {
    this.onClose()
  }

  modificar (esquema) {
    this.data = {
      ...this.data,
      cobro_impuesto_estatal: esquema.cobro_impuesto_estatal,
      comision_porcentaje: esquema.comision_porcentaje,
      comision_porcentaje_op: esquema.comision_porcentaje_op,
      comision_porcentaje_sa: esquema.comision_porcentaje_sa,
      id_esquema: esquema.id_esquema,
      id_metodo_calculo_comision: esquema.id_metodo_calculo_comision,
      id_metodo_calculo_suministro: esquema.id_metodo_calculo_suministro,
      id_tipo_comision: esquema.id_tipo_comision,
      metodo_calculo_comision: esquema.metodo_calculo_comision,
      metodo_calculo_suministro: esquema.metodo_calculo_suministro,
      tipo_comision: esquema.tipo_comision,
      iva_porcentaje: esquema.iva_porcentaje,
      impuestos: esquema.impuestos,
    }
  }
}

module.component('nominasNominaInformacionConfiguracionEditar', {
  controller: NominasNominaInformacionConfiguracionEditarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    calculado: '<',
    acumulado: '<',
    onChange: '&',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/configuracion/editar/component.js